import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useEffect, useState } from 'react';
import { useApi } from 'app/api/APIProvider';
import { TransactionCards } from 'entities/TransactionCards';
import { TransactionCardsTheme } from 'entities/TransactionCards/TransactionCards';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { PolicyCard } from 'entities/PolicyCard';
import { PolicyCardTheme } from 'entities/PolicyCard/PolicyCard';
import { ConditionCard } from 'entities/ConditionCard/ConditionCard';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import plug from 'shared/assets/img/pages/card-plug.png';
import Logo from 'shared/assets/img/sber_logo.png';
import PlayIcon from 'shared/assets/icons/playIcon.svg';
import cls from './ContributionPage.module.scss';

interface IDeposit {
    earnedAll: number
    initialMoney: string
    level: number
    status: string
    yearMoney: string
}

export const ContributionPage = () => {
    const api = useApi();
    const [closedDeposits, setClosedDeposits] = useState<IDeposit[]>([]);
    const [wallet, setWallet] = useState(0);
    const [hasOpenedProducts, setHasOpenedProducts] = useState<boolean>(false);
    const [deposit, setDeposit] = useState({
        earnedAll: "500",
        initialMoney: 500,
        level: null,
        status: false,
        earnedPercent: 2222
    });
    const [credit, setCredit] = useState<any>({
        sum: '100000',
        status: false,
    });
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const banner = {
        name: "У вас еще нет вкладов",
        description: "Вы можете зайти в раздел мои финансы и открыть вклад уже сейчас",
        img: plug,
        button: {
            text: 'Мои финансы',
            url: '/finance'
        },
        cost: "",
        type: "banner",
    }

    const conditions = [
        {
            name: 'Банковский счет и дебетовая карта',
            wallet: wallet
        },
        {
            name: 'Банковский вклад 8% годовых',
            depositAmount: deposit.initialMoney,
            refillPerYear: deposit.initialMoney,
            percentageRate: '8%',
            totalSum: deposit.earnedAll,
            status: deposit.status,
            button: {
                url: '/finance/policy/deposit8',
            },
        },
        {
            name: 'Кредит на любые цели под 10% годовых на 10 лет',
            loanSum: credit.sum,
            percentageRate: '10%',
            term: '10 лет',
            status: credit.status,
        },
        {
            name: 'Кредит на любые цели под 10% годовых на 10 лет',
            loanSum: credit?.otherCredit?.sum,
            percentageRate: '10%',
            term: '10 лет',
            status: !!credit?.otherCredit?.status,
        }
    ]

    const getUserMoney = async () => {
        const { deposits } = await api.GetUserMoney('deposit');
        const { wallet } = await api.GetAllSum();
        const { deposit8, credit10, debit_card } = await api.GetFinanceInfo();
        setClosedDeposits(deposits.filter((deposit: IDeposit) => !deposit.status));
        setHasOpenedProducts(!![deposit8, credit10, debit_card].filter((value) => value.status).length);
        setWallet(wallet);
        setCredit(credit10);
        setDeposit(deposit8);
        setIsLoaded(true);
    }

    useEffect(() => {
        getUserMoney();
    }, []);

    if (!isLoaded) return <PageLoader />
    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    {
                        closedDeposits.length === 0 && !hasOpenedProducts ? (
                            <>
                                <Text className={cls.title} color="#353850" size={TextSize.text_36}>Мои вклады</Text>
                                <PolicyCard banner={banner} theme={PolicyCardTheme.banner} />
                            </>

                        ) : (
                            <>
                                {
                                    hasOpenedProducts && (
                                        <div>
                                            <Text className={cls.title} color="#353850" size={TextSize.text_36}>Мои вклады</Text>
                                            <div className={cls.conditionsWrapper}>
                                                {
                                                    conditions.map((condition) => {
                                                        if (condition.status === false) return;
                                                        return <ConditionCard conditions={condition}/>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    closedDeposits.length !== 0 && (
                                        <div>
                                            <Text className={cls.title} color="#353850" size={TextSize.text_36}>История</Text>
                                            <div className={cls.cardsWrapper}>
                                                {
                                                    closedDeposits.map((transaction, index) => {
                                                        return <TransactionCards transaction={transaction} theme={TransactionCardsTheme.closed} key={index} />
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        )
                    }
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon/>}
                        >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="Разумные деньги фото №13" />
            </Wrapper>
        </div>
    );
};
